import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { LoginRoutingModule } from './login-routing.module';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { LoginService } from './services/login.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SignInUpComponent } from './components/sign-in-up/sign-in-up.component';
import { RegisterComponent } from './components/register/register.component';

@NgModule({
  imports: [
    PdfViewerModule,
    CommonModule, FormsModule, LoginRoutingModule, SharedModule,
  ],
  exports: [
    LoginComponent, ChangePasswordComponent,SignInUpComponent
  ],
  declarations: [LoginComponent, ChangePasswordComponent, SignInUpComponent, RegisterComponent],
  providers: [LoginService]
})
export class LoginModule {
  static forRootOrChild(): ModuleWithProviders<LoginModule> {
    return {
      ngModule: LoginModule,

      // the singletone providers - one instance for all modules
      providers: [LoginService
      ]
    };
  }
}

